import React from 'react';
import { RolloverActionsProps } from '../types/ProvisionalPromotionTypes';
import { FilterColumn } from '../../IdCards/styled';
import CustomMenuItem from '../../../components/CustomMenuItem/CustomMenuItem';
import { ActionButton, RolloverActionsContainer } from '../styled';
import TextInputWithIcon from '../../../components/TextInputWithIcon';

const RolloverActions: React.FC<RolloverActionsProps> = ({
  rolloverAy,
  selectedCount,
  onPromoteClick
}) => {
  return (
    <RolloverActionsContainer>
      <FilterColumn>
        <TextInputWithIcon
          select
          size='small'
          value={rolloverAy}
          label='Rollover AY'
          placeholder='Select Rollover AY'
          disabled
          SelectProps={{
            displayEmpty: true,
            renderValue: (value: any) => value || 'Rollover AY'
          }}
        >
          <CustomMenuItem value={rolloverAy}>{rolloverAy}</CustomMenuItem>
        </TextInputWithIcon>
      </FilterColumn>
      {selectedCount > 0 && (
        <ActionButton
          variant='contained'
          color='primary'
          onClick={onPromoteClick}
        >
          Provisionally Promote
        </ActionButton>
      )}
    </RolloverActionsContainer>
  );
};

export default RolloverActions;
